import { useDatasetDataRes } from '../types/types';

// Wraps a single bare row into the useDatasetDataRes shape returned by the string
// fetch path. Inverse of getDataFromDatasetRequest(..., true).
export const wrapRowAsDatasetDataRes = (
  row: unknown,
  datasetId: string
): useDatasetDataRes => {
  if (!row) return undefined;
  return {
    data: [row],
    datasetId,
    lazy: false,
    cachedQueryId: undefined,
    totalCount: undefined,
    api: '',
  };
};
